import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=2efb014d&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=2efb014d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb014d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2efb014d')) {
      api.createRecord('2efb014d', component.options)
    } else {
      api.reload('2efb014d', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=2efb014d&scoped=true&", function () {
      api.rerender('2efb014d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Loader.vue"
export default component.exports